/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/menu/menu',['require','underscore','jquery','backbone','core/base-screen','modernizr','core/engine'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  var Backbone = require('backbone');
  var BaseScreen = require('core/base-screen');
  var Modernizr = require('modernizr');
  var Engine = require('core/engine');

  //var FILTER_TYPE_NONE = '';
  var FILTER_TYPE_FA1 = 'fa-1';
  var FILTER_TYPE_FA2 = 'fa-2';
  var FILTER_TYPE_FA3 = 'fa-3';
  var FILTER_TYPE_CPR1 = 'cpr-1';
  var FILTER_TYPE_CPR2 = 'cpr-2';
  var FILTER_TYPE_CPR3 = 'cpr-3';

  var FILTER_ARR_FA = [FILTER_TYPE_FA1, FILTER_TYPE_FA2, FILTER_TYPE_FA3];
  var FILTER_ARR_CPR = [FILTER_TYPE_CPR1, FILTER_TYPE_CPR2, FILTER_TYPE_CPR3];

  var CUR_TAB = 'cpr';
  var CUR_FILTER = 'cpr-1';
  var FIRST_INIT = true;

  /*****************************************************************************************************************///}

  var Menu = BaseScreen.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    events: {
      'click .tab-button.enabled': 'filterTabHandler',
      'click .level-button.enabled': 'filterItemsHandler',
      'click .drop-pin': 'itemPressed',
      'mouseover .drop-pin, .header-btn, .print-button': 'itemOver',
      'mouseout .drop-pin, .header-btn, .print-button': 'itemOut',
      'click .help-btn': 'helpClickHandler',
      'click .guide-btn,.intro-guide-btn': 'guideClickHandler',
      'click .print-button': 'printClickHandler'
    },

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      BaseScreen.prototype.initialize.apply(this, arguments);

      //var locations = new Backbone.Collection(this.model.get('locations'));
      var locations = new Backbone.Collection(Engine.module('Paging').find('modules').content.models);
      var individualLocations = new Backbone.Collection(Engine.module('Paging').find('individual-pages', 'menuMC').content.models);
      individualLocations = _.filter(individualLocations.models, function(obj, index, src) {
        return _.has(obj, 'attributes.menuMC');//['menuMC'])
      });
      locations.add(individualLocations);
      ////console.log('individualLocations', individualLocations);
      var hasFA = false;
      locations.each(function(obj, index)
      {
        //console.log('each', obj, obj.status());
        if (obj.id.indexOf('fa_') !== -1)
          hasFA = true;

        if (!obj.medal)
          return;

        var objStatus = obj.status();
        var btnText = 'Start';
        var statusText = 'Completed';
        obj.set('menuMedal', obj.medal());
        obj.set('dataStatus', objStatus);

        if (objStatus === 'complete')
        {
          btnText = 'Replay';
        }
        else if (objStatus === 'retry')
        {
          statusText = 'Failed';
          btnText = 'Retry';
        }

        obj.set('btnText', btnText);
        obj.set('statusText', statusText);
        //obj.status = "incomplete";
      });

      if (hasFA && FIRST_INIT)
      {
        FIRST_INIT = false;
        CUR_TAB = 'fa';
        CUR_FILTER = 'fa-1';
      }

     // this.model.set('locations', Engine.module('Paging').find('modules').content.toJSON());

      this.model.set('locations', locations.toJSON());
      this.model.set('courseTitle', Engine.config.courseInfo.courseTitle);
    },

    onRender: function()
    {
      this.$el.find('#joyride-data ol').joyride('destroy');
      this.$el.find('#joyride-data ol').joyride({
        autoStart: false,
        //expose: false,
        //modal: false,
        timer: 0,
        template: {
          link: '<a href="javascript:void(0)" class="joyride-close-tip delete-item"></a>'
        },
        nextButton: true,
        tipContainer: this.$el.find('#joyride-container'),
        postRideCallback: _.bind(this.guideComplete, this)
        //preStepCallback: _.bind(this.guideStep, this)
      });

      var __status = Engine.module('Paging').completionStatus();
      //console.log('perc', __perc);
      this.$el.find('.progress-meter .inner-bar').css('width', __status.perc + '%');
      this.$el.find('[data-id=completion-status]').html(__status.complete + ' of ' + __status.total + ' missions completed');
      this.$el.find('.menu-container').on('scroll', _.bind(this.onMenuScrollHandler, this));

      if (Engine.module('Paging').courseComplete)
        this.$el.addClass('course-complete');

      if (Engine.module('Paging').finishedModule)
        console.log('FINISHED MODULE', Engine.module('Paging').finishedModule);

      this.checkCertificate();
    },

    onShow: function()
    {
      this._itemPanelMC = this.$el.find('[data-mc=panel_mc]');
      //console.log('onshow');
      /*for (var $l = 1; $l <= 3; $l++)
      {
        if (Engine.module('Paging').checkAllModulesCompleteByLevel($l))
        {
          //Engine.module('Achievement').setAchievementCompleteByCode('complete_level_' + $l.toString());
          //Achievement.setAchievementCompleteByCode('complete_level_' + $l.toString());
        }
      }*/

      if (Modernizr.touch)
      {
        //Engine.module('Media').play('empty_audio.mp3', {channel: Engine.module('Media').primaryChannel});
        //Engine.module('Media').play('empty_audio.mp3', {channel: Engine.module('Media').itemChannel});
      }

      $(window).on('MSHoldVisual', function(e) {
        e.preventDefault();
        return false;
      }, false);
      // $(document).on('contextmenu', function(e) {
      //   e.preventDefault();
      //   return false;
      // });

      //this.playAmbientAudio(false, false);
      //this.checkTabs();
      //this.filterItems();
      //console.log('page: ', this.page);
      //throw Error();

      if (Modernizr.touch && !Engine.module('Media').audioAllowed)
      {
        this.$el.find('[data-mc=intro_mc] .intro-box').hide();
        this.playMedia({filename: 'empty_audio.mp3', caption: '', character: ''}, null, _.bind(this.mediaEnabled, this, this.page.get('complete')));
      }
      else
      {
        this.mediaEnabled(this.page.get('complete'));
      }

      this.finish();
    },

    onMenuScrollHandler: function(evt)
    {
      //console.log('scroll', this.$el.find('.menu-container').scrollTop());
      if (this.$el.find('.menu-container').scrollTop() >= 100)
        this.condenseMenu();
      else
        this.expandMenu();
    },

    condenseMenu: function()
    {
      this.$el.attr('data-menu', 'condensed');
    },

    expandMenu: function()
    {
      this.$el.attr('data-menu', 'standard');
    },

    mediaEnabled: function(_complete)
    {
      if ($('body .media-test').length)
        return;

      if (_complete)
        this.hideIntro();
      else
        this.setupIntro();
    },

    setupIntro: function()
    {
      //console.log('setup', Engine.config.courseInfo);
      var $h1 = $('<h1>').html(Engine.config.courseInfo.courseTitle);
      this.$el.find('[data-mc=intro_title]').append($h1);
      this.showIntroVideo();
    },

    showIntroVideo: function()
    {
      this.$el.find('[data-mc=intro_mc] .intro-box').hide();
      this.playMedia(this.model.get('introMedia'), null, _.bind(this.showIntroPanel, this));
    },

    showIntroPanel: function(e, a)
    {
      if ($('body .media-test').length)
        return;

      var __delay = 0;
      if (this.channel)
      {
        this.channel.cleanup();
        __delay = 500;
      }
      _.delay(_.bind(function() {
        this.$el.find('[data-mc=intro_mc] .intro-box').show();
      }, this), __delay);
    },

    hideIntro: function()
    {
      this.$el.find('[data-mc=intro_mc]').hide();
      this.playMedia({filename: 'silence.mp3'});
    },

    itemPressed: function(e)
    {
      var locked = $(e.currentTarget).attr('data-locked');
      if (locked === 'true')
      {
        //console.log('locked');
        return false;
      }

      var id = $(e.currentTarget).attr('data-link');

      Engine.module('Navigation').go(id);

      return false;
    },

    itemOver: function(e)
    {
      if (Modernizr.touch)
        return;

      $(e.currentTarget).addClass('over');
      /*var mc = $(e.currentTarget);
      var id = mc.attr('data-mc');
      var module = Engine.module('Paging').getModules()[id] || Engine.module('Paging').find(id);
      var title = module.get('location');
      var location = module.get('description');
      var required = module.get('required');

      this.showModuleTitle(title, location, mc, required);*/
    },

    itemOut: function(e)
    {
      $(e.currentTarget).removeClass('over');
      //this.hideModuleTitle();
    },

    showModuleTitle: function(title, location, mc, required)
    {
      required = required || false;

      this._itemPanelMC.show();
      var itemLeft = mc.position().left + mc.width();
      var itemTop = mc.position().top;

      this._itemPanelMC.css({left: itemLeft, top: itemTop});

      if (mc.position().left > 600)
      {
        this._itemPanelMC.css('left', mc.position().left - (this._itemPanelMC.width()));
      }

      this._itemPanelMC.find('.location .body').html(title);
      this._itemPanelMC.find('.mission .body').html(location);
    },

    hideModuleTitle: function()
    {
      this._itemPanelMC.hide();
    },

    checkTabs: function()
    {
      var $hasCPRMods = (Engine.module('Paging').getAllCPRMods(FILTER_ARR_CPR).length > 0);
      var $hasFAMods = (Engine.module('Paging').getAllFAMods(FILTER_ARR_FA).length > 0);

      $('[data-mc=cpr_mc]').hide();
      $('[data-mc=fa_mc]').hide();

      if ($hasCPRMods)
      {
        $('[data-mc=cpr_mc]').show().find('.tab-button').addClass('enabled');
      }
      else
      {
        CUR_TAB = 'fa';
      }

      if ($hasFAMods)
      {
        $('[data-mc=fa_mc]').show().find('.tab-button').addClass('enabled');
      }
      //console.log('check tabs', $hasFAMods, $hasCPRMods);
      this.filterTab(false);
    },

    filterTabHandler: function(e)
    {
      var btn = $(e.currentTarget);
      CUR_TAB = btn.parent().attr('data-filter');
      this.filterTab();
    },

    filterItemsHandler: function(e)
    {
      var btn = $(e.currentTarget);
      CUR_FILTER = btn.attr('data-filter');
      this.filterItems();
    },

    filterTab: function(__updateFilter)
    {
      __updateFilter = __updateFilter === undefined ? true : __updateFilter;
      $('.filter-panel').removeClass('active');
      var panel = $('[data-filter=' + CUR_TAB + ']').addClass('active');
      if (__updateFilter)
        CUR_FILTER = panel.find('.level-1').attr('data-filter');
      this.filterItems();
    },

    filterItems: function()
    {
      // var modFullArr = Module.getAllModsByFilter(CUR_FILTER);
      // var displayArr = (CUR_FILTER == FILTER_TYPE_CPR1 || CUR_FILTER == FILTER_TYPE_FA1) ? modFullArr : modArr;
      var displayArr = Engine.module('Paging').getModulesByFilter(CUR_FILTER);
      //console.log('displayArr', displayArr);
      //var module;
      //var itemBtn;
      //var item;

      //this.hideModules();
      this.$el.attr('data-filter', CUR_FILTER);

      var $lvlBtns = this.$el.find('.level-button');
      $lvlBtns.removeClass('active');

      _.each($lvlBtns, function(btnEl) {
        var $btn = $(btnEl);
        var $lvlFilter = $btn.attr('data-filter');
        if ($lvlFilter === CUR_FILTER)
          $btn.addClass('active');

        if (Engine.module('Paging').getAvailableModsByFilter($lvlFilter).length > 0)
          $btn.addClass('enabled');
        else
          $btn.addClass('disabled');

        if (Engine.module('Paging').getNewModsByFilter($lvlFilter).length > 0)
          $btn.addClass('has-new');

        //this.$el.find('.level-button[data-filter=' + CUR_FILTER + ']').addClass('active');
      }, this);

      // _.each(this._menuBtnsvar btn:MovieClip in this._menuBtnsArr) {
      //   Button(btn.wrapper).enable();
      // }

      /*_.each(displayArr, function(module) {
        item = commonContainer.find('[data-mc=find]')('#' + module.name);
        if (item.length)
        {
          itemBtn = item.wrapper;
          item.visible = true;

          if (module.prereqsComplete || !CourseSettings.singleton.forcedOrder)
          {
            itemBtn.enable();
          }
        }
      });*/

      var seenOnly = true;
      var commonContainer = this.$el.find('.common-container');
      commonContainer.find('.check-vis').hide();

      if (CUR_FILTER === FILTER_TYPE_CPR3 || CUR_FILTER === FILTER_TYPE_FA3)
      {
        if (commonContainer.find('[data-mc=lvl3_mc]').length)
        {
          commonContainer.find('[data-mc=lvl3_mc]').show();
        }
        seenOnly = false;
      }
      else if (CUR_FILTER === FILTER_TYPE_CPR2 || CUR_FILTER === FILTER_TYPE_FA2)
      {
        if (commonContainer.find('[data-mc=lvl2_mc]').length)
        {
          commonContainer.find('[data-mc=lvl2_mc]').show();
        }
      }
      else if (CUR_FILTER === FILTER_TYPE_CPR1 || CUR_FILTER === FILTER_TYPE_FA1)
      {
        if (commonContainer.find('[data-mc=lvl1_mc]').length)
        {
          commonContainer.find('[data-mc=lvl1_mc]').show();
        }
      }

      //commonContainer.find('[data-mc=filterComplete_mc]').show();
      //console.log('check mods', Engine.module('Paging').checkAllModulesSeenByFilter(CUR_FILTER));
      if (Engine.module('Paging').checkAllModulesSeenByFilter(CUR_FILTER, displayArr, seenOnly) && CUR_FILTER !== FILTER_TYPE_CPR3 && CUR_FILTER !== FILTER_TYPE_FA3)
      {
        commonContainer.find('[data-mc=filterComplete_mc]').show();
      }

      if (Engine.module('Paging').courseComplete)
        this.$el.addClass('course-complete');

      this.checkCertificate();
    },

    checkCertificate: function()
    {
      console.log('check cert', Engine.config.mapSettings);
      if (Engine.module('Paging').courseComplete)
      {
        this.$el.addClass('course-complete');
        if (Engine.config.mapSettings.showCert !== false)
          this.$el.find('.print-button').show();
        else
          this.$el.find('.print-button').hide();

      }
    },

    hideModules: function()
    {
      this.$el.attr('data-filter', '');
    },

    setInterface: function()
    {
      //BaseScreen.prototype.finish.apply(this);

      this.radio.trigger('ui.update', { next: false, home: false, back: false, help: true, caption: false, badge: true });
    },

    finish: function()
    {
      BaseScreen.prototype.finish.apply(this);

      //Engine.module('Achievement').setAchievementCompleteByCode('event_course_welcome');
      this.radio.trigger('ui.update', { next: false });
    },

    helpClickHandler: function($e)
    {
      this.radio.trigger('ui.button.pressed.help');
    },

    guideClickHandler: function($e)
    {
      this.hideIntro();
      this.$el.addClass('guide-active');
      this.$el.find('.menu-container').scrollTop(0);
      this.$el.find('#joyride-data ol').joyride('restart');
      //this.radio.trigger('ui.button.pressed.help');
    },

    guideComplete: function()
    {
      this.$el.removeClass('guide-active');
    },

    printClickHandler: function($e)
    {
      //alert('add print code');
      var $courseComplete = Engine.config.mapSettings.completePage || 'course_complete';
      Engine.module('Navigation').go($courseComplete);
      //Engine.module('Navigation').go('course_complete');
     // this.radio.trigger('print.cert');
    },

    customDestroy: function()
    {
      this.$el.find('#joyride-data ol').joyride('destroy');
      this.$el.find('.menu-container').off('scroll');
    }

  /*****************************************************************************************************************///}

  });

  return Menu;

});

